import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class AiDataTransformerService {
    private _instructionsBehaviorSubject = new BehaviorSubject<any>(null);
    private _commentData = new BehaviorSubject<any>(null);
    private _timeSheetData = new BehaviorSubject<any>(null);
    private _meetingsData = new BehaviorSubject<any>(null);
    private _taskBoardData = new BehaviorSubject<any>(null);
    private _taskMasterData = new BehaviorSubject<any>(null);
    private _attendanceData = new BehaviorSubject<any>(null);
    private _alertData = new BehaviorSubject<any>(null);
    private _sprintData = new BehaviorSubject<any>(null);
    private _reminderData = new BehaviorSubject<any>(null);

    constructor() {}

    setInstructionsData(data: any) {
        this._instructionsBehaviorSubject.next(data);
    }

    getInstructionsData() {
        return this._instructionsBehaviorSubject.asObservable();
    }

    setCommentData(data: any) {
        this._commentData.next(data);
    }

    getCommentData() {
        return this._commentData.asObservable();
    }

    setTimeSheetData(data: any) {
        this._timeSheetData.next(data);
    }

    getTimeSheetData() {
        return this._timeSheetData.asObservable();
    }

    setMeetingsData(data: any) {
        this._meetingsData.next(data);
    }

    getMeetingsData() {
        return this._meetingsData.asObservable().pipe(distinctUntilChanged());
    }

    setTaskBoardData(data: any) {
        this._taskBoardData.next(data);
    }

    getTaskBoardData() {
        return this._taskBoardData.asObservable();
    }

    setTaskMasterData(data: any) {
        this._taskMasterData.next(data);
    }

    getTaskMasterData() {
        return this._taskMasterData.asObservable();
    }
    setAttendanceData(data: any) {
        this._attendanceData.next(data);
    }
    getAttendanceData() {
        return this._attendanceData.asObservable();
    }

    setAlertData(data: any) {
        this._alertData.next(data);
    }

    getAlertData() {
        return this._alertData.asObservable();
    }

    setSprintData(data: any) {
        this._sprintData.next(data);
    }

    getSprintData() {
        return this._sprintData.asObservable();
    }

    setReminderData(data: any) {
        this._reminderData.next(data);
    }

    getReminderDataValue() {
        return this._reminderData.getValue();
    }

    resetAllData() {
        this._instructionsBehaviorSubject.next(null);
        this._commentData.next(null);
        this._timeSheetData.next(null);
        this._meetingsData.next(null);
        this._taskBoardData.next(null);
        this._taskMasterData.next(null);
        this._alertData.next(null);
        this._sprintData.next(null);
        this._attendanceData.next(null);
        this._reminderData.next(null);
    }
}
